import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "hamburger", "close"]

  toggle() {
    const isHidden = this.menuTarget.classList.contains("hidden")
    this.menuTarget.classList.toggle("hidden", !isHidden)
    this.hamburgerTarget.classList.toggle("hidden", isHidden)
    this.closeTarget.classList.toggle("hidden", !isHidden)
  }

  // Ferme le menu si on clique en dehors
  close(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
      this.hamburgerTarget.classList.remove("hidden")
      this.closeTarget.classList.add("hidden")
    }
  }
}
